import { useState } from 'react';
import { generateGIF as generateGIFUtil } from '../utils/gifExporter';
import { RENDER_CONFIG } from '../constants/renderConfig';

/**
 * useGifExport Hook
 *
 * Manages GIF export functionality with progress tracking.
 * Coordinates with the gifExporter utility for actual GIF generation.
 */
export const useGifExport = () => {
  const [gifProgress, setGifProgress] = useState({ current: 0, total: 0, percent: 0 });
  const [isGeneratingGif, setIsGeneratingGif] = useState(false);
  const [gifComplete, setGifComplete] = useState(false);

  const generateGif = ({ width, height, columns, generateASCII, backgroundColor, foregroundColor }) => {
    setIsGeneratingGif(true);
    setGifProgress({ current: 0, total: 0, percent: 0 });
    setGifComplete(false);

    generateGIFUtil({
      width,
      height,
      columns,
      generateASCII,
      backgroundColor,
      foregroundColor,
      onProgress: (progress) => {
        setGifProgress(progress);
      },
      onComplete: () => {
        setIsGeneratingGif(false);
        setGifComplete(true);
        setTimeout(() => {
          setGifComplete(false);
        }, RENDER_CONFIG.toastDuration);
      }
    });
  };

  return {
    gifProgress,
    isGeneratingGif,
    gifComplete,
    generateGif
  };
};
